import React from "react";

import Button from "components/ui/button/Button";

export function ClearSelectedButton({ count, onClear }: { count: number; onClear: () => void }) {
  return (
    <Button onClick={onClear} buttonType="tertiary" icon="xCircle">
      {count} selected
    </Button>
  );
}
